if (!window.langSelectorNavInit) {
  window.langSelectorNavInit = true;

  // Shopify's /localization endpoint drops the entry segment of metaobject
  // web-page URLs from return_to, landing on the parent page. Locale is
  // path-based, so navigate straight to the localized URL instead of
  // submitting the localization form (capture phase runs before
  // localization-form.js's submit handler).
  document.addEventListener(
    'click',
    function (event) {
      const link = event.target.closest('.lang-selector .disclosure__link');
      if (!link) return;

      event.preventDefault();
      event.stopPropagation();

      if (link.hasAttribute('aria-current')) return;

      try {
        sessionStorage.setItem('lang-scope', 'local');
      } catch (e) {}

      const selector = link.closest('.lang-selector');
      const currentRoot = selector.dataset.currentRoot || '/';
      const targetRoot = link.dataset.rootUrl || '/';

      let path = window.location.pathname;
      if (currentRoot !== '/' && path.indexOf(currentRoot) === 0) {
        path = path.slice(currentRoot.length) || '/';
      }

      const localizedPath = targetRoot === '/' ? path : targetRoot + path;
      // Page position can't map across languages (each locale paginates its
      // own filtered list), so land on page 1; other params survive. Array
      // paginates (metaobjects) use a suffixed param like page_6e9b4af6.
      const params = new URLSearchParams(window.location.search);
      Array.from(params.keys())
        .filter((key) => /^page(_[a-z0-9]+)?$/i.test(key))
        .forEach((key) => params.delete(key));
      const query = params.toString();
      window.location.assign(window.location.origin + localizedPath + (query ? '?' + query : ''));
    },
    true
  );
}
